import type { paths } from "@/api-schema";
import { alphartisApiAxios } from "@/config/axios";
import { useQuery } from "@tanstack/react-query";
import { optionsWithDefaults } from "../_helpers/options-with-defaults";
import { Options } from "../_types";

export const CUSTOMER_BY_UUID_RESOURCE = "customer" as const;
export const CUSTOMER_BY_UUID_API_PATH = `/v1/${CUSTOMER_BY_UUID_RESOURCE}/{uuid}` as const;

export type CustomerByUuidParameters = paths[typeof CUSTOMER_BY_UUID_API_PATH]["get"]["parameters"]["query"];
export type CustomerByUuidResponse =
  paths[typeof CUSTOMER_BY_UUID_API_PATH]["get"]["responses"][200]["content"]["application/json"];

export function useCustomerByUuidQuery(uuid: string, options?: Options<CustomerByUuidParameters, never>) {
  const optionsWithDefaultsResolved = optionsWithDefaults<Options<CustomerByUuidParameters, never>>(options);

  const requestParameters = {
    ...(optionsWithDefaultsResolved.parameters || {}),
    extend: optionsWithDefaultsResolved.parameters?.extend || [],
  };

  return useQuery({
    enabled: !!uuid,
    queryKey: [CUSTOMER_BY_UUID_RESOURCE, uuid, { parameters: requestParameters }],
    queryFn: async () => {
      const response = await alphartisApiAxios.get<CustomerByUuidResponse>(`/v1/${CUSTOMER_BY_UUID_RESOURCE}/${uuid}`, {
        params: requestParameters,
      });

      return response.data;
    },
  });
}
